import { Breadcrumbs, Typography, Link } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { useObrasConcretagemCadastroViewModel } from "../../viewModels/obras_concretagem_cadastro_view_model";
import { DefaultFormFileInput } from "../../../../../common/components/default_form_file_input";
import { DefaultFormFillableInput } from "../../../../../common/components/default_form_fillable_input";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { FormTimeMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_time_masked_input";
import { ResistenciaInput } from "../Obras_concretagem/components/resistencia_input";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ObrasReportModals } from "../../components/obras_report_modals";

import AlertError from "../../../../../common/components/alert_error";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import FormContainer from "../../../../../common/components/form_container";
import BottomBar from "../../../../../common/components/bottom_bar";
import { FornecedorDrawer } from "../../../../../common/components/drawers_api/drawers/fornecedor_drawer";

/**
 * ObrasConcretagemCadastro
 */

export const ObrasConcretagemCadastro = () => {
  const viewModel = useObrasConcretagemCadastroViewModel();
  return (
    <>
      <form onSubmit={viewModel.handleMapaConcretagemSubmit}>

        {/**
        * ObrasTopBar
        */}

        <ObrasTopBar
          obrasReportState={viewModel.obrasReportState}
          state={viewModel.obrasTopHeaderState}
          selectedObra={viewModel.selectedObraHeaderInfo ?? null}
          leftBackSlotButton={
            <div className="w-[100px]">
              <PrimaryButton
                onClick={() => viewModel.handleMapaConcretagemNew()}
                startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}>
                Novo
              </PrimaryButton>
            </div>
          }
          onBack={viewModel.handleBack}>
        </ObrasTopBar>

        <div className="flex w-full gap-2 flex-col px-4 pt-2 mb-32">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
            </Link>
            <Link underline="hover" color="inherit" component={'span'}>
              <LinkTo to={`/Obras_concretagem?id=${viewModel.idObra}`}>Mapa de Concretagem</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Mapa de Concretagem Cadastro
            </Typography>
          </Breadcrumbs>

          {/**
          * ObrasTopHeader
          */}

          <ObrasTopHeader
            title="Mapa de Concretagem Cadastro"
            selectedObra={viewModel.selectedObraHeaderInfo ?? null}
            onReload={viewModel.handleReload}
          />

          {
            viewModel.errorMessage !== undefined
              ? (
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.errorMessage}
                    onTryAgain={viewModel.handleReload}
                  />
                </div>
              ) : (
                <div className="w-full flex flex-col bg-light-mode-2 dark:bg-dark-mode-2 rounded-[4px] border-[1px] border-border-light-gray dark:border-border-dark-gray px-4 pb-4">
                  <FormContainer
                    title={"Informações Sobre o Concreto Utilizado"}
                    arrangement="fullRow"
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <div className="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
                        <FormDatePickerInput
                          name='dataConcretagem'
                          label='Data da Concretagem'
                          required={true}
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='tipoConcreto'
                          label='Tipo do Concreto'
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='slupFlowSolicitado'
                          label='Slump/Flow Solicitado'
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
                        <DefaultFormInput
                          name='resistMpa'
                          label='Resist. (MPA)'
                          reactHookForm={viewModel.hookForm}
                        />

                        <FormRadioGroupInput
                          name='ensaioConcreto'
                          label='Ensaio do Concreto'
                          options={viewModel.ensaioConcretoOptions}
                          showCleanButton={true}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
                        <DefaultFormInput
                          name='moduloResistenciaGPA'
                          label='Módulo de resistência (GPA)'
                          reactHookForm={viewModel.hookForm}
                        />

                        <FormRadioGroupInput
                          name='ensaioModuloElasticidade'
                          label='Ensaio do Módulo de Elasticidade'
                          options={viewModel.ensaioModuloElasticidadeOptions}
                          showCleanButton={true}
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>
                    </>
                  </FormContainer>

                  <FormContainer
                    title={"Informações Sobre a Entrega"}
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <DefaultFormFillableInput
                        name='fornecedor'
                        label='Fornecedor'
                        fillableBoxLabel='Preencher o fornecedor'
                        options={viewModel.fornecedoresDropdown}
                        getOptionKey={x => x.idFornecedor}
                        getOptionLabel={x => x.nomeFantasia}
                        reactHookForm={viewModel.hookForm}
                        onNew={viewModel.handleNewFornecedor}
                      />

                      <DefaultFormInput
                        name='nroCarro'
                        label='Nº do Carro'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='nroNotaFiscal'
                        label='Nº da Nota Fiscal'
                        reactHookForm={viewModel.hookForm}
                      />

                      <FormTimeMaskedInput
                        name='saidaUsina'
                        label='Saída Usina'
                        reactHookForm={viewModel.hookForm}
                      />

                      <FormTimeMaskedInput
                        name='entradaObra'
                        label='Entrada Obra'
                        reactHookForm={viewModel.hookForm}
                      />

                      <FormTimeMaskedInput
                        name='inicioLancamento'
                        label='Início Lançamento'
                        reactHookForm={viewModel.hookForm}
                      />

                      <FormTimeMaskedInput
                        name='finalLancamento'
                        label='Final Lançamento'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='qteM3'
                        label='Qte. (M3)'
                        reactHookForm={viewModel.hookForm}
                      />

                      <DefaultFormInput
                        name='slumpFlowEncontrado'
                        label='Slump/Flow Encontrado'
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title='Local do Lançamento'
                    arrangement="fullRow"
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <p className="text-red-400">
                        Descreva de forma detalhada, onde o concreto foi ou será lançado. Quando aplicável inclua o pavimento e o nome/nº da peça. (Máximo 8.000 Caracteres)
                      </p>

                      <DefaultFormInput
                        name='localLancamento'
                        label='Local do Lançamento'
                        required={true}
                        multiline={true}
                        rows={10}
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title='Informações para o Laboratório'
                    arrangement="fullRow"
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <div className='grid grid-cols-1 lg:grid-cols-2'>
                        <FormRadioGroupInput
                          name='enviadoLaboratorio'
                          label='Enviado para o Laboratório?'
                          options={viewModel.aprovadoOptions}
                          showCleanButton={true}
                          reactHookForm={viewModel.hookForm}
                        />
                        {
                          Number(viewModel.enviadoLaboratorio) === 1 &&
                          <FormDatePickerInput
                            name='dataEnviadoLaboratorio'
                            label='Data de envio para o Laboratório'
                            reactHookForm={viewModel.hookForm}
                          />
                        }
                      </div>

                      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
                        <DefaultFormInput
                          name='nroLaudo'
                          label='Nº do laudo'
                          reactHookForm={viewModel.hookForm}
                        />

                        <FormDatePickerInput
                          name='dataEnvioObra'
                          label='Data de Envio pela obra'
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormFillableInput
                          name='laboratorio'
                          label='Laboratório'
                          fillableBoxLabel='Preencher o Laboratório'
                          options={viewModel.fornecedoresDropdown}
                          getOptionKey={x => x.idFornecedor}
                          getOptionLabel={x => x.nomeFantasia}
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='nroCorpoProva'
                          label='Nº Corpo de Prova'
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='nroLote'
                          label='Nº lote'
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <DefaultFormInput
                        name='instrucaoLancamento'
                        label='Instrução de Rompimento'
                        multiline={true}
                        rows={10}
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title={"Resistência a Compressão Resultados"}
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <ResistenciaInput
                        inputName='resistencia12hs'
                        checkboxName='resistencia12hs_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ horas: 12 }}
                        label='12 horas'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia4'
                        checkboxName='resistencia4_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 3 }}
                        label='3 dias'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia7'
                        checkboxName='resistencia7_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 7 }}
                        label='7 dias'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia14'
                        checkboxName='resistencia14_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 14 }}
                        label='14 dias'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia21'
                        checkboxName='resistencia21_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 21 }}
                        label='21 dias'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia28'
                        checkboxName='resistencia28_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 28 }}
                        label='28 dias'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia56'
                        checkboxName='resistencia56_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 56 }}
                        label='56 dias'
                        reactHookForm={viewModel.hookForm}
                      />

                      <ResistenciaInput
                        inputName='resistencia63'
                        checkboxName='resistencia63_checkbox'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 63 }}
                        label='63 dias'
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title=''
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        <DefaultFormInput
                          name='idade1'
                          label='Idade'
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='resultado1'
                          label='Resultado'
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        <DefaultFormInput
                          name='idade2'
                          label='Idade'
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='resultado2'
                          label='Resultado'
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>

                      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                        <DefaultFormInput
                          name='idade3'
                          label='Idade'
                          reactHookForm={viewModel.hookForm}
                        />

                        <DefaultFormInput
                          name='resultado3'
                          label='Resultado'
                          reactHookForm={viewModel.hookForm}
                        />
                      </div>
                    </>
                  </FormContainer>

                  <FormContainer
                    title={"Módulo de Elasticidade"}
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <ResistenciaInput
                        inputName='elasticidade28'
                        checkboxName='checkElasticidade28'
                        dataConcretagem={viewModel.dataConcretagem}
                        duracaoConcretagem={{ dias: 28 }}
                        label='28 dias'
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title=''
                    arrangement="fullRow"
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <div className='grid grid-cols-1 lg:grid-cols-2'>
                        <FormRadioGroupInput
                          name='aprovado'
                          label='Aprovado?'
                          options={viewModel.aprovadoOptions}
                          showCleanButton={true}
                          reactHookForm={viewModel.hookForm}
                        />
                        {
                          Number(viewModel.aprovado) === 1 &&
                          <FormDatePickerInput
                            name='dataAprovacao'
                            label='Data da Aprovação'
                            reactHookForm={viewModel.hookForm}
                          />
                        }
                      </div>

                      <DefaultFormFillableInput
                        name='responsavelAprovacao'
                        label='Responsável Pela Aprovação'
                        fillableBoxLabel='Preencher o responsável'
                        options={viewModel.funcionariosRespAprovDropdown}
                        getOptionDisabled={x => !x.canBeSelected}
                        getOptionKey={x => x.idFuncionario}
                        getOptionLabel={x => x.nome}
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title=''
                    arrangement="fullRow"
                    boldTitle={true}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <DefaultFormInput
                        name='observacao'
                        label='Observação'
                        multiline={true}
                        rows={10}
                        reactHookForm={viewModel.hookForm}
                      />
                    </>
                  </FormContainer>

                  <FormContainer
                    title='Anexo'
                    arrangement="fullRow"
                    boldTitle={true}
                    border={false}
                    paddingTop="normal"
                    paddingBottom="small">
                    <>
                      <p className="text-black dark:text-white">
                        Exemplos de anexo: Fotos do slump/flow, relatório do laboratório, mapa de concretagem.
                      </p>

                      <div className="w-[25rem]">
                        <DefaultFormFileInput
                          name='arquivo1'
                          saving={viewModel.saving}
                          loading={viewModel.loading}
                          filename={
                            viewModel.mapaConcretagem && viewModel.mapaConcretagem.nomeArquivo &&
                              viewModel.arquivo1 === null && viewModel.limparArquivo1 === false
                              ? viewModel.mapaConcretagem.nomeArquivo
                              : undefined
                          }
                          reactHookForm={viewModel.hookForm}
                          onDownload={_ => viewModel.handleMapaConcretagemArquivoDownload(1)}
                          onChangeFile={() => viewModel.hookForm.setValue('limparArquivo1', false)}
                          onLimparArquivo={() => {
                            viewModel.hookForm.setValue('limparArquivo1', true)
                          }}
                        />

                        <DefaultFormFileInput
                          name='arquivo2'
                          saving={viewModel.saving}
                          loading={viewModel.loading}
                          filename={
                            viewModel.mapaConcretagem && viewModel.mapaConcretagem.nomeArquivo1 &&
                              viewModel.arquivo2 === null && viewModel.limparArquivo2 === false
                              ? viewModel.mapaConcretagem.nomeArquivo1
                              : undefined
                          }
                          reactHookForm={viewModel.hookForm}
                          onDownload={_ => viewModel.handleMapaConcretagemArquivoDownload(2)}
                          onChangeFile={() => viewModel.hookForm.setValue('limparArquivo2', false)}
                          onLimparArquivo={() => {
                            viewModel.hookForm.setValue('limparArquivo2', true)
                          }}
                        />

                        <DefaultFormFileInput
                          name='arquivo3'
                          saving={viewModel.saving}
                          loading={viewModel.loading}
                          filename={
                            viewModel.mapaConcretagem && viewModel.mapaConcretagem.nomeArquivo2 &&
                              viewModel.arquivo3 === null && viewModel.limparArquivo3 === false
                              ? viewModel.mapaConcretagem.nomeArquivo2
                              : undefined
                          }
                          reactHookForm={viewModel.hookForm}
                          onDownload={_ => viewModel.handleMapaConcretagemArquivoDownload(3)}
                          onChangeFile={() => viewModel.hookForm.setValue('limparArquivo3', false)}
                          onLimparArquivo={() => {
                            viewModel.hookForm.setValue('limparArquivo3', true)
                          }}
                        />

                        <DefaultFormFileInput
                          name='arquivo4'
                          saving={viewModel.saving}
                          loading={viewModel.loading}
                          filename={
                            viewModel.mapaConcretagem && viewModel.mapaConcretagem.nomeArquivo3 &&
                              viewModel.arquivo4 === null && viewModel.limparArquivo4 === false
                              ? viewModel.mapaConcretagem.nomeArquivo3
                              : undefined
                          }
                          reactHookForm={viewModel.hookForm}
                          onDownload={_ => viewModel.handleMapaConcretagemArquivoDownload(4)}
                          onChangeFile={() => viewModel.hookForm.setValue('limparArquivo4', false)}
                          onLimparArquivo={() => {
                            viewModel.hookForm.setValue('limparArquivo4', true)
                          }}
                        />
                      </div>
                    </>
                  </FormContainer>
                </div>
              )
          }
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.idMapaConcretagem) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory()}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      {/**
        * Modals.
        */}

      <FornecedorDrawer
        saving={viewModel.saving}
        state={viewModel.fornecedorStateDrawer}
        centrosCustoDropdown={viewModel.centroCustosDropdown}
      />

      {/**
        * Fornecedores.
        */}

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      {/**
        * Modal historico de alterações.
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
    </>
  );
}